import React from "react";
import { graphql, StaticQuery } from "gatsby";

const query = graphql`
  query ProductPageBanner {
    sanityProductPageBanner {
      content
      enabled
      image_mobile {
        asset {
          fluid {
            base64
            src
            srcSet
          }
        }
      }
      image_desktop {
        asset {
          fluid {
            base64
            src
            srcSet
          }
        }
      }
    }
  }
`;

const ProductPageBanner = () => {
  return (
    <StaticQuery
      query={query}
      render={({ sanityProductPageBanner: banner }) => {
        const hasImage =
          banner.image_desktop.asset?.fluid?.src ||
          banner.image_mobile.asset?.fluid?.src;
        return (
          <section className="grid">
            <div className="grid-end-12 sm:mt-20 mt-v4 mb-5 text-center ">
              {!hasImage && (
                <div className="w-full bg-black py-5 px-4 rounded-xl text-white">
                  <p className="text-banner">{banner.content}</p>
                </div>
              )}

              <img
                className="block xs:hidden w-full"
                src={banner.image_desktop.asset.fluid.src}
                alt={banner.content}
              />
              <img
                className="xs:inline-block hidden max-w-full"
                src={banner.image_mobile.asset.fluid.src}
                alt={banner.content}
              />
            </div>
          </section>
        );
      }}
    ></StaticQuery>
  );
};

export default ProductPageBanner;
